import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { PreviewGallery, DeviceToggle } from "@/pages/admin/regie/AdStudio";

export default function PreviewShare() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  const [device, setDevice] = useState("mobile");
  const [variant, setVariant] = useState(0);
  useEffect(() => {
    const m = document.createElement("meta");
    m.name = "robots"; m.content = "noindex, nofollow";
    document.head.appendChild(m);
    api.get(`/studio-share/${token}`).then(({ data }) => setD(data)).catch((e) => setErr(errMsg(e)));
    return () => { document.head.removeChild(m); };
  }, [token]);
  return (
    <div className="min-h-screen bg-[#05070D] px-4 py-6 text-white" data-testid="preview-share">
      <div className="mx-auto max-w-5xl space-y-4">
        <p className="rounded-lg bg-amber-300 px-3 py-2 text-xs font-extrabold text-[#05070D]">APERÇU INTERNE — non publié, lecture seule, aucun comptage</p>
        {err && <p className="text-sm text-red-300" data-testid="preview-share-error">{err}</p>}
        {d && (<>
          <div className="flex flex-wrap items-center gap-2"><h1 className="mr-auto font-display text-2xl font-extrabold uppercase">{d.campaign.name}</h1><DeviceToggle device={device} set={setDevice} /></div>
          {d.variants.length > 1 && <div className="flex gap-1.5">{d.variants.map((v, i) => <button key={v.creative_id} onClick={() => setVariant(i)} className={`rounded-full px-2.5 py-1 text-xs ${i === variant ? "bg-white text-[#05070D]" : "bg-white/5"}`}>Visuel {String.fromCharCode(65 + i)}</button>)}</div>}
          <PreviewGallery data={d} device={device} variant={variant} compare={device === "mobile"} />
          <p className="text-[11px] text-slate-500">Expire le {new Date(d.expires_at).toLocaleString("fr-CA")}.</p>
        </>)}
      </div>
    </div>);
}
